import { InjectionToken } from '@angular/core';

export interface FormlyFormConfig {
  stackOnPhone?: boolean;
}

export const FORMLY_FORM_CONFIG = new InjectionToken<FormlyFormConfig>('FORMLY_FORM_CONFIG');
